(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[939],{

/***/ 8199:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(2811);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6528);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);





function KeysNewComponent() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("keys").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container align-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: "".concat((_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default().keys), " row"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "delivery",
                            srcSet: "https://public.choose.app/website/2023/Delivery@2x.png 2x,https://public.choose.app/website/2023/Delivery@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Delivery.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("delivery")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Notifications@2x.png 2x,https://public.choose.app/website/2023/Notifications@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Notifications.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("retour")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Paiement@2x.png 2x,https://public.choose.app/website/2023/Paiement@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Paiement.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("payment")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/ServiceClient@2x.png 2x,https://public.choose.app/website/2023/ServiceClient@3x.png 3x",
                            src: "https://public.choose.app/website/2023/ServiceClient.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("support")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (KeysNewComponent);


/***/ }),

/***/ 2811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5125);
/* harmony import */ var _styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6514);
/* harmony import */ var _new_components_header_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5365);
/* harmony import */ var _new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5374);
/* harmony import */ var _new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8205);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3496);
/* harmony import */ var _api_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1936);









function PricingScreen(props) {
    var getDescription = function getDescription() {
        return "Choose pricing plans";
    };
    var getTitle = function getTitle() {
        return "Pricing | Choose";
    };
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$G)("pricing"), i18n = ref.i18n, t = ref.t;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        (0,_api_analytics__WEBPACK_IMPORTED_MODULE_7__/* .trackPage */ .K)("Pricing", {
            store: props.store,
            lang: props.lang,
            language: props.language,
            i18N: i18n.language
        });
    }, [
        i18n.language,
        props.lang,
        props.language,
        props.store
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().pricing),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                description: getDescription(),
                title: getTitle()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_header_Header__WEBPACK_IMPORTED_MODULE_3__/* .HeaderNewComponent */ .w, {
                disableScroll: true,
                store: props.store,
                language: i18n.language
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: t("header_title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: t("header_subtitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().plansContainer),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planCard), " ").concat((_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().freePlan)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planHeader),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: "Free"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().price),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().currency),
                                                        children: t("currency")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().amount),
                                                        children: "0"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().period),
                                                        children: "/month"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planFeatures),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("free_feature_1")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("free_feature_2")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("free_feature_3")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("free_feature_4")
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planButton),
                                        children: t("get_started_button")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planCard), " ").concat((_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().customPlan)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().badge),
                                        children: "Popular"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planHeader),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: t("custom_plan_title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().price),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().customPrice),
                                                    children: t("custom_pricing")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planFeatures),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("custom_feature_1")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("custom_feature_2")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("custom_feature_3")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("custom_feature_4")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("custom_feature_5")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: "https://public.choose.app/website/new/images/Check.svg",
                                                            alt: "check"
                                                        }),
                                                        t("custom_feature_6")
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "".concat((_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().planButton), " ").concat((_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().primary)),
                                        children: t("contact_sales_button")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: (_styles_pages_pricing_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hr)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                store: props.store
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PricingScreen);


/***/ }),

/***/ 6528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keys":"Keys_keys__HpzY5"};

/***/ }),

/***/ 5125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pricing":"pricing_pricing__t98N6","header":"pricing_header__BNmYa","plansContainer":"pricing_plansContainer__YZnUw","planCard":"pricing_planCard__SVT0a","customPlan":"pricing_customPlan__UEK_A","badge":"pricing_badge__V_Kln","planHeader":"pricing_planHeader__w9qUU","price":"pricing_price__t4ssQ","currency":"pricing_currency__w0_1g","amount":"pricing_amount__hbEDW","period":"pricing_period__qjErC","customPrice":"pricing_customPrice__VD6wj","planFeatures":"pricing_planFeatures__QF1_H","planButton":"pricing_planButton__rbH1g","primary":"pricing_primary__Pqd1z","hr":"pricing_hr__1waOM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [195,530,774,888,179], function() { return __webpack_exec__(8199); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);